import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFastest = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_497_110",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			className: "custom-rect",
			width: 20,
			height: 20,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_497_110)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.6722 15.5834C11.1217 15.5834 9.80308 15.0401 8.71641 13.9534C7.62988 12.8669 7.08662 11.5483 7.08662 9.99779C7.08662 8.45876 7.62988 7.14383 8.71641 6.053C9.80308 4.96216 11.1217 4.41675 12.6722 4.41675C14.2113 4.41675 15.5261 4.96216 16.6168 6.053C17.7077 7.14383 18.2531 8.45876 18.2531 9.99779C18.2531 11.5483 17.7077 12.8669 16.6168 13.9534C15.5261 15.0401 14.2113 15.5834 12.6722 15.5834ZM12.6593 14.5001C13.9163 14.5001 14.9822 14.0661 15.8572 13.198C16.7322 12.3299 17.1697 11.2674 17.1697 10.0105C17.1697 8.75355 16.7322 7.68758 15.8572 6.81258C14.9822 5.93758 13.9197 5.50008 12.6697 5.50008C11.4059 5.50008 10.3399 5.93758 9.47183 6.81258C8.60377 7.68758 8.16974 8.75008 8.16974 10.0001C8.16974 11.264 8.60377 12.3299 9.47183 13.198C10.3399 14.0661 11.4024 14.5001 12.6593 14.5001ZM14.4583 12.5753L15.2243 11.8095L13.2097 9.79071V7.12821H12.1281V10.2295L14.4583 12.5753ZM2.99683 7.29175V6.20841H5.83662V7.29175H2.99683ZM1.99683 10.5417V9.45842H5.83662V10.5417H1.99683ZM2.99683 13.7917V12.7084H5.83662V13.7917H2.99683Z",
			fill: "currentColor"
		})
	})]
});
export default SvgFastest;
